import Box from "@mui/material/Box";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import Link from "../Link";

type LinkProps = {
  link: string;
  title: string;
};

const Links = () => {
  const { selectedUserId } = useCustomerTicketsPage();
  const linksData: LinkProps[] = [
    {
      link: `/Summary/${selectedUserId}`,
      title: "Open Customer Profile",
    },
    {
      link: `/Finance/${selectedUserId}`,
      title: "Open Transaction History",
    },
    {
      link: `/Bonuses/${selectedUserId}`,
      title: "Open Bonuses",
    },
  ];

  return (
    <Box display="flex" flexDirection="column" rowGap="0.5rem">
      {linksData.map((data, index) => (
        <Link key={index} link={data.link} title={data.title} />
      ))}
    </Box>
  );
};

export default Links;
